<template>
  <div class="table-vuex">
    <ThePagePreloader
      v-if="!isVisible && tableIsLoading"
      position="component"
    />

    <AppTable
      v-if="isVisible"
      :headers="tableHeaders"
      :data="tableData"
      :loading="tableIsLoading"
      :all-items-active="allItemsChecked"
      :has-checkbox="hasCheckbox"
      is-special
      @toggle-active-item="toggleItemChecked"
      @toggle-active-all="toggleItemCheckedAll"
      @show-this-item="goToUpdate"
      @sort-item="loadSorted"
      @onSelect="onSelect"
    />

    <AppNoRecordsPlaceholder v-if="!isVisible && !tableIsLoading" />
  </div>
</template>

<script>
import AppTable from '@/components/page/table/AppTable'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import ThePagePreloader from '@/components/page/ThePagePreloader'

export default {
  // Таблица работает в связке с Vuex default по namespaced
  name: 'TableVuex',
  components: {
    AppNoRecordsPlaceholder,
    AppTable,
    ThePagePreloader
  },
  props: {
    namespaced: {
      type: String,
      required: true
    },
    hasCheckbox: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    isVisible () {
      return this.$store.getters[this.namespaced + '/visibleTable']
    },
    tableHeaders () {
      return this.$store.getters[this.namespaced + '/getTableHeaders']
    },
    tableData () {
      return this.$store.getters[this.namespaced + '/getList']
    },
    tableIsLoading () {
      return this.$store.getters[this.namespaced + '/getIsLoading']
    },
    allItemsChecked () {
      return this.$store.getters[this.namespaced + '/getAllItemsChecked']
    }
  },
  methods: {
    toggleItemChecked (id) {
      this.$store.commit(this.namespaced + '/SET_ITEM_CHECKED', id)
    },
    toggleItemCheckedAll () {
      this.$store.commit(this.namespaced + '/SET_ALL_ITEMS_CHECKED')
    },
    goToUpdate (id) {
      this.$store.dispatch(this.namespaced + '/goToPageById', id)
    },
    async loadSorted (sort) {
      return this.$store.dispatch(this.namespaced + '/loadSorted', sort)
    },
    async onSelect (data) {
      await this.$store.dispatch(this.namespaced + '/updateItemSelect', data)
    }
  }
}
</script>

<style lang="scss">
.table-vuex {
  position: relative;
}
</style>
